import { useSavingsStore } from '@/store/useSavingsStore'
import { useUserStore } from '@/store/useUserStore'
import { useGetWallet, type WalletCurrency } from '@/domain'
import { NumberPad } from '@/components/NumberPad'

export const SetGoalNumberPad: React.FC = () => {
  // Store state - используем тот же подход что и в withdraw/first-deposit
  const isFiatMode = useSavingsStore((s) => s.goal.isFiatMode)
  const fiatAmount = useSavingsStore((s) => s.goal.fiatAmount)
  const cryptoAmount = useSavingsStore((s) => s.goal.cryptoAmount)
  const setGoal = useSavingsStore((s) => s.setGoal)

  const user = useUserStore((s) => s.user)
  const displayCurrency = user?.display_currency || 'USD'

  // Получаем данные кошелька для USDT
  const { data: walletData } = useGetWallet()
  const completeCurrencies = useUserStore((s) => s.wallet?.completeCurrencies)

  // Находим USDT в кошельке пользователя
  const usdtWallet = completeCurrencies?.find(
    (currency: WalletCurrency) => currency.code === 'USDT',
  )

  // Функции для обновления сумм - прямые, как в withdraw
  const setFiatAmount = (amount: { amount: string; code: string }) => {
    setGoal({
      fiatAmount: amount,
    })
  }

  const setCryptoAmount = (amount: { amount: string; code: string }) => {
    setGoal({
      cryptoAmount: amount,
    })
  }

  // Создаем объект selectedCurrency с правильной структурой
  const selectedCurrency = {
    code: 'USDT',
    pricePerUnit: usdtWallet?.pricePerUnit || 1.0, // Используем реальный курс из кошелька
  }

  // Функция тряски - store автоматически сбросит triggerShake через 600ms
  const shakeComponent = () => {
    setGoal({ triggerShake: true })
  }

  return (
    <NumberPad
      isFiatMode={isFiatMode}
      fiatAmount={fiatAmount}
      cryptoAmount={cryptoAmount}
      setFiatAmount={setFiatAmount}
      setCryptoAmount={setCryptoAmount}
      selectedCurrency={selectedCurrency}
      shakeComponent={shakeComponent}
      maxLength={12}
    />
  )
}
